module.exports = __webpack_public_path__ + "img/2010 winteressen 011.1bad5781.jpg";